import React, { useState, useEffect } from "react";

import Skeleton from "react-loading-skeleton";

const NumericCell: React.FC<NumericCellProps> = ({ value }) => {
  const [displayValue, setDisplayValue] = useState(value);
  useEffect(() => {
    let val = value;
    if (val && val > 1000) {
      val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    setDisplayValue(val);
  }, [value]);

  return <>{displayValue === undefined ? <Skeleton /> : <>{displayValue}</>}</>;
};

export default NumericCell;

export interface NumericCellProps {
  value: number | string | undefined;
}
